import '../styles.scss';
import React from 'react';
import { GeckoAvatar } from '@geckolabs/gecko-react-ui';

const Attendees = ({ attendees }) => {
    const sortedAttendees = attendees.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        return nameA > nameB ? 1 : -1;
    });

    return (
        <div className="attendee-list-container d-flex flex-column">
            <div className="attendee-list d-flex flex-column flex-grow-1">
                <ul>{sortedAttendees.map((attendee, i) => (
                    <Attendee attendee={attendee} key={i} />
                ))}</ul>
            </div>
        </div>
    );
}

export const Attendee = ({ attendee, i }) => {
    return (
        <div key={i}>
            <GeckoAvatar name={attendee.name} />
            {attendee.name}
        </div>
    );
}

export default Attendees;